import BaseService from './base.service'

export default class PickingService extends BaseService {
    validatePedido(tipoEscaneo, idPedido, fnSuccess, fnError) {
        return this.getApi().get(`/picking/validatePedido?tipoEscaneo=${tipoEscaneo}&idpedido=${idPedido}`)
            .then(response => fnSuccess(response))
            .catch(error => fnError(this.getMessageFromError(error, 'Error al validar el pedido')));
    }
}
